import React from 'react';
import { Button, Card, Container, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Select } from '@material-ui/core';
import BackButton from '../Shared/BackButton';
import styled from 'styled-components';
import Layout from '../Shared/Layout';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useState } from 'react';
import {useForm} from "@inertiajs/inertia-react";
import ReportForm from "../Shared/ReportForm";
import Alert from "@material-ui/lab/Alert";
import { Trans } from "../utils/i18n";

const Wrapper = styled(Card)`
  margin: 20px 0;
  padding: 20px;
`;

const H1 = styled.h1`
    display: inline-block;
    margin-right: 30px;
`;

const ReportTypes = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ReportType = styled.div`
  text-align: center;
  flex-grow: 1;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid ${({ theme }) => theme.primary};
  background-color: ${({ selected, theme }) => selected ? theme.primary : 'transparent'};
  color: ${({ selected, theme }) => selected ? theme.white : theme.primary};

  //&:first-of-type {
  //  border-top-left-radius: 5px;
  //  border-bottom-left-radius: 5px;
  //}
  //
  //&:last-of-type {
  //  border-top-right-radius: 5px;
  //  border-bottom-right-radius: 5px;
  //}
`;

const ReportLabel = styled.p`
  font-size: 15.7px;
  font-family: 'Roboto', sans-serif;
  color: rgba(0, 0, 0, 0.54);
`;

export default function Report({ reports, errors }) {
  const [date, setDate] = useState(new Date());
  const [radio, setRadio] = useState('');
  const [reportId, setReportId] = useState('');

  const handleReportTypeChange = event => {
      setReportId(parseInt(event.target.dataset.value));
  }

  const report = reports.find((item) => item.id === reportId);

  return (
    <Container maxWidth="lg">
      <Wrapper>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <BackButton />
          </Grid>
          <Grid item xs={12}>
            <H1><Trans i18nKey="dashboard.reports">Reports</Trans></H1>
              {errors && Object.values(errors).map(item => <Alert severity="error">{ item }</Alert>)}
          </Grid>
          <Grid item xs={12}>
            <ReportLabel><Trans i18nKey="report.report.label">Select a report</Trans></ReportLabel>
            <ReportTypes value={reportId} onClick={handleReportTypeChange}>
                {
                    reports.map((item, key) => <ReportType data-value={item.id} selected={reportId === item.id}>{ item.name }</ReportType>)
                }
            </ReportTypes>
          </Grid>
        </Grid>
            {
                report && <ReportForm key={report.id} report={report}/>
            }
      </Wrapper>
    </Container>
  )
}

Report.layout = page => <Layout children={page} />
